import { Navigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/use-auth';

export function RootIndex() {
  const { isAuthenticated } = useAuth();
  return <Navigate to={isAuthenticated ? '/app' : '/login'} replace />;
}
